import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="px-4 md:px-6 py-14 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold">韩漫画网</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              下拉式免费漫画在线观看平台，涵盖韩国漫画大全资源。操作简单、内容全面，是您漫画收藏的最佳选择。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">漫画分类</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 4).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">更多分类</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(4).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
              <Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap">
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">联系我们</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line"></i>
                <span>hello@nikson.cn</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-customer-service-line"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </div>
              <div className="flex gap-3 mt-4">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微博" rel="nofollow">
                  <i className="ri-links-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微信" rel="nofollow">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="B站" rel="nofollow">
                  <i className="ri-movie-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="小红书" rel="nofollow">
                  <i className="ri-chat-smile-2-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 韩漫画网. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-background-50 transition-colors whitespace-nowrap">用户协议</a>
            <a href="#" className="hover:text-background-50 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-background-50 transition-colors whitespace-nowrap">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}